import { SweetalertService } from './../../shared/services/sweetalert.service';
import { ManagementUserService } from './../../shared/services/api/management-user.service';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { LicenseService } from '../../shared/services/license.service';

export const licenseGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const managementUserService = inject(ManagementUserService);
  const sweetalertService = inject(SweetalertService);
  const licenseService = inject(LicenseService);

  if (licenseService.getActiveLicense()) {
    return true;
  }

  return managementUserService.getActiveLicense().pipe(
    map((response) => {
      const hasLicense = response.license != null;

      // Aktive Lizenz im LicenseService speichern
      licenseService.setActiveLicense(response);

      if (hasLicense) {
        return true;
      } else {
        return router.createUrlTree(['/noLicense']);
      }
    }),
    catchError((error) => {
      console.error('License check failed:', error);

      // Spezifisch auf "not_found" prüfen
      if (error.status === 404 && error.error?.code === 'not_found') {
        // Optional: unterschiedliche Behandlung
        console.warn('Benutzer hat keine gültige Lizenz');
      } else {
        sweetalertService.error(
          'Die Lizenz konnte nicht abgefragt werden. Bitte kontaktieren Sie uns unter office@routini.at'
        );
      }

      // Bei Fehler auf noLicense umleiten
      return of(router.createUrlTree(['/noLicense']));
    })
  );
};
